import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

import { fields } from "utils/data";
import Form from "../../uiComponents/Form";
import { useDispatch } from "react-redux";
import { updateUser } from "../../../store/actions/user";

const initialValues = {
  name: "",
  email: "",
  phone: "",
  company: "",
  role: "",
};

const SignUp = ({ setLoader }) => {
  const { t } = useTranslation();

  const [agree, setAgree] = useState(false);
  const dispatch = useDispatch();
  const handleSubmit = (values) => {
    dispatch(updateUser(values, setLoader));
  };
  const agreement = () => {
    setAgree((prevState) => !prevState);
  };
  return (
    <div className="sign-up">
      <h1>{t('create_account')}</h1>
      <hr />
      <Form
        fields={fields}
        initValues={initialValues}
        submitValue={t('create_account')}
        submitFunc={handleSubmit}
        agreement={agree}
      >
        <label className="checkbox checkbox-control">
            {t('i_agree_to_the')}&nbsp;
          <a
            href="https://bim-search.com/en/legals/"
            target="_blank"
            rel="noreferrer"
          >
            {t('terms_of_use')}
          </a>
            &nbsp; {t('and_the')}&nbsp; 
            <a
                href="https://bim-search.com/en/legals/"
                target="_blank"
                rel="noreferrer"
            >
                {t('privacy_statement')}
            </a>
          <input
            type="checkbox"
            name="agree"
            checked={agree}
            onChange={agreement}
          />
          <div className="checkbox-indicator"></div>
        </label>
      </Form>
    </div>
  );
};

export default SignUp;
